module.exports = __webpack_public_path__ + "img/showcase-instaview-fr-ca.a788b50b.jpg";